import { GroupSelectItemInterface, GroupSelectOptionsInterface } from '@components/common';

export const sortByChecked = (sortedOptions: GroupSelectOptionsInterface[]): GroupSelectOptionsInterface[] => {
	const sortItemsByChecked = (items: Array<GroupSelectItemInterface>): Array<GroupSelectItemInterface> => {
		return items
			.map(item => {
				const sortedNestedItems = item.items ? sortItemsByChecked(item.items) : undefined;

				return {
					...item,
					items: sortedNestedItems,
				};
			})
			.sort((a, b) => {
				if (a.checked && !b.checked) return -1;
				if (!a.checked && b.checked) return 1;

				return 0;
			});
	};

	const sortedOptionsCopy = sortedOptions.map(option => ({
		...option,
		items: sortItemsByChecked(option.items),
	}));

	const sortedOptionsWithAllSelectedFirst = sortedOptionsCopy.sort((a, b) => {
		const allOptionsSelectedA = a.items.every(item => item.checked
			|| (item.items?.every(subItem => subItem.checked) ?? false));
		const allOptionsSelectedB = b.items.every(item => item.checked
			|| (item.items?.every(subItem => subItem.checked) ?? false));

		if (allOptionsSelectedA && allOptionsSelectedB) {
			return a.category.name.localeCompare(b.category.name);
		}
		if (allOptionsSelectedA && !allOptionsSelectedB) {
			return -1;
		}
		if (!allOptionsSelectedA && allOptionsSelectedB) {
			return 1;
		}

		const checkedCountA = a.items.reduce((count, item) =>
				count + (item.checked ? 1 : 0) + (item.items ? item.items.filter(subItem =>
					subItem.checked).length : 0),
			0);
		const checkedCountB = b.items.reduce((count, item) =>
				count + (item.checked ? 1 : 0) + (item.items ? item.items.filter(subItem =>
					subItem.checked).length : 0),
			0);

		return checkedCountB - checkedCountA;
	});

	return sortedOptionsWithAllSelectedFirst;
};

export const sortByName = (sortedOptions: GroupSelectOptionsInterface[]): GroupSelectOptionsInterface[] => {
	const sortItemsByName = (items: Array<GroupSelectItemInterface>): Array<GroupSelectItemInterface> => {
		return items
			.map(item => ({
				...item,
				items: item.items ? sortItemsByName(item.items) : undefined,
			}))
			.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
	};

	const sortedOptionsCopy = sortedOptions.map(option => ({
		...option,
		items: sortItemsByName(option.items),
	}));

	sortedOptionsCopy.sort((a, b) => {
		const categoryA = a.category.name || '';
		const categoryB = b.category.name || '';
		if (categoryA !== categoryB) {
			return categoryA.localeCompare(categoryB);
		}

		const titleA = a.items[0]?.title || '';
		const titleB = b.items[0]?.title || '';
		return titleA.localeCompare(titleB);
	});

	return sortedOptionsCopy;
};

export const filterHiddenOptions = (options: GroupSelectOptionsInterface[]): GroupSelectOptionsInterface[] => {
	const filteredOptions = options
		.filter((option) => !option.category.isHidden)
		.map((option) => ({
			...option,
			items: option.items.filter((item) => !item.isHidden),
		}));

	return filteredOptions;
};

export const areAllItemsChecked = (items: Array<GroupSelectItemInterface> = []): boolean => {
	return items.every(item => {
		if (item.items && item.items.length > 0) {
			return areAllItemsChecked(item.items);
		}

		return item.checked === true;
	});
};
